import React from 'react';
import { TextField } from '@mui/material';

const NumberField = ({ label, value, onChange, disabled, required }) => {
  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      margin='normal'
      value={value || ""}
      required={required}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      type='number'
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
          transition: "0.3s",
          height: "40px",

          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9aa8b8",
          },

          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#c1cddb"
          },

          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#c1cddb",
            borderWidth: "2px",
          },
        },

        "& .MuiInputLabel-root": {
          color: "#c9b7b7",
          fontSize: "0.75rem",
          "&.Mui-focused": {
            color: "#c1cddb",
            fontSize: "1rem",
          },
          "&.MuiFormLabel-filled": {
            fontSize: "1rem",
          }
        },

        "& .MuiInputBase-input": {
          color: "#c7b1b1",
          padding: "8px 12px",
        },

        marginBottom: "8px",

        ...(disabled && {
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#40454a !important",
            height: "40px",

            "& .MuiOutlinedInput-notchedOutline": {
              borderStyle: "solid !important",
              borderColor: "#a7bbcf !important",
            },
          },

          "& .MuiInputLabel-root": {
            color: "#a7bbcf !important",
          },

          "& .MuiInputBase-input": {
            WebkitTextFillColor: "#a7bbcf !important",
          }
        }),
      }}
    />
  );
};

export default NumberField;